import * as React from 'react';
import Button from "storybookComponents/Button"
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Field from "content/Campgain/ScheduleInvite/multiTagField.js"
import SelectorComponent from "components/SelectorComponents"

const frequencyFilterValue = [
  {
    id: "daily",
    value: "Daily"
  },
  {
    id: "weekly",
    value: "Weekly"
  },
]

const ScheduleReport = ({ classes, onClose }) => {
  const [values, setValues] = React.useState({
    pdf: true,
    csv: true,
    emails: []
  })

  const [frequency, setFrequency] = React.useState(['daily'])

  const handleChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.checked
    })
  }

  const setFieldValue = (keyName, emails) => {
    setValues({
      ...values,
      emails
    })
  }

  const getCustomLabelForFrequency = (selected, count, name, open) => {
    // if (!name) {
    //   return <div className={`${classes.placeholder} ${open && classes.openOpacity}`}>Contact</div>
    // }
    return <div className={`${classes.selectedPlaceholder} ${open && classes.openOpacity}`}>{name}</div>
  }


  const handleFrequencyChange = (values) => {
    setFrequency(values)
  }

  return <div>
    <div className={classes.header}>Select Format of Email Report</div>
    <FormControlLabel control={<Checkbox checked={values.pdf} name="pdf" onChange={handleChange} />} label="PDF" /><br />
    <FormControlLabel control={<Checkbox checked={values.csv} name="csv" onChange={handleChange} />} label="CSV" /><br />
    <div className={classes.subtitle}>Select atleast one format</div>
    <Field values={values} setFieldValue={setFieldValue} placeholder="example@example.com" keyName="emails" label="Email Address" className={{
      container: classes.emailFieldContainer,
      label: classes.label
    }} />


    <div className={classes.selectFieldContainer}>
      <div className={classes.label}>Frequency of Reports</div>
      <SelectorComponent
        optionValue={frequencyFilterValue}
        onChange={handleFrequencyChange}
        singleSelect={true}
        value={frequency}
        getCustomLabel={getCustomLabelForFrequency}
        disableSearch={true}
        disableAllSelect={true}
        height={145}
        width={260}
      />
    </div>
    <div className={classes.subtitle}>Report will be sent out at 8AM EST</div>
    <div className={classes.selectFieldContainer}>
      <div className={classes.label}>Frequency of Reports</div>
      <SelectorComponent
        optionValue={frequencyFilterValue}
        onChange={handleFrequencyChange}
        singleSelect={true}
        value={frequency}
        getCustomLabel={getCustomLabelForFrequency}
        disableSearch={true}
        disableAllSelect={true}
        height={145}
        width={260}
      />
    </div>

    <div className={classes.bottomFlexBox}>
      <Button className={classes.btnStyle} variant="tertiary" onClick={onClose}>Cancel</Button>
      <Button className={classes.btnStyle} state={(!values.pdf && !values.csv) ? "inactive" : "active"} onClick={onClose}>Start Schedule</Button>
    </div>
  </div>
}

export default ScheduleReport


